export function confirmAdminRoleChange({
  operation,
  role,
  username,
  confirmFn = globalThis.confirm,
}) {
  if (role !== 'admin') return true;
  if (typeof confirmFn !== 'function') return false;

  const label = username || 'this user';
  if (operation === 'grant') {
    return confirmFn(
      `Grant administrator access to "${label}"?\n\n`
      + 'This gives full control of users, moderation, feature flags, and site operations.',
    );
  }
  if (operation === 'revoke') {
    return confirmFn(
      `Revoke administrator access from "${label}"?\n\n`
      + 'They will lose admin portal access unless they are a bootstrap administrator.',
    );
  }
  return false;
}
